import { Content } from '../models/content';

export const englishContent: Content = {
  translation: {
    title:
      'Cardano staking pool operator based in Europe<br /> designed and built by <a href="mailto:adapool_charles@pm.me">@Charles</a> and <a href="mailto:adapool_mikael@pm.me">@Mika</a>.',
    whoAreWe: 'Who we are?',
    whyJoinUs: 'Why join us?',
    poolDetails: 'Pool details',
    s1: {
      p1: 'We are Charles 😊 and Mika 😉, a partnership of two French entrepreneurs motivated to democratize the use of crypto-currencies.',
      p2: 'Mika, who helps administrations in their digital transformations, brings his technical and human experience. Charles brings over a decade of experience in software engineering. Together, we are enthusiastically participating in the development of the Cardano network!',
      p3: 'We have been involved in cryptocurrencies since 2017, when we had the chance to make a profit at the top of the market. We discovered the Cardano project at that moment, and since then, we have been following it with great interest. Our goal with ADA Pool Europe is to create a community of people who share our values, believe in Cardano, and to which we would like to offer a good capital pooling experience.',
      p4: 'Our goal with ADA Pool Europe is to create a community of people who share our values, believe in Cardano and to which we offer a good capital pooling experience.',
    },
    s2: {
      p1: 'We are motivated to democratize the use of crypto-currencies.',
      p2: ' high availability infrastructure',
      p3: ' with limited fees',
      p4: ' open to the largest audience possible',
      p5: ' dedicated and secure servers',
      p6: 'Our Europe-based Cardano staking pool is dedicated to strengthening and decentralizing the Cardano network. \n We offer high-availability, reliable and secure staking, based on two relay nodes and one producer node in enterprise-class server centers. Our goal is to create a good participant experience.',
      p7: "We put a strong focus on the performance and security of our pool infrastructure. We would like to allow as many people as possible to participate in the crypto adventure.",
      p8: 'By staking your ADAs in our pool, you participate in the operation of the Cardano network.',
      p9: "✔&nbsp;Your ADAs are never blocked, you can transfer them anytime and without penalty&nbsp;;<br><br> ✔&nbsp;Your ADAs are always in your wallet, they stay with you. You can't lose them by the 'staking' method &nbsp;;<br><br> ✔&nbsp;Your rewards are automatically reinvested. Every 5 days you receive your share of the winnings which are automatically stacked&nbsp;;<br><br> ✔&nbsp;You can start stacking your ADA, even if you have very few.",
    },
    s3: {
      p1: 'Participating in the Cardano network is easy!<br>You just have to stake your ADA crypto-currencies in our "adapool-europe" pool.',
      p2: 'The identifier to enter to delegate your ADA:',
      p3: 'Interactive widget',
      p4: 'Pledge',
      p5: 'Owners:',
      p6: 'Value:',
      p7: ' Stake',
      p8: 'Delegators:',
      p9: 'Value:',
      p10:'Fees',
      p11:'Variable fees:',
      p12:'Fixed fee:',
      p13:'Crypto-currency price'
    },
    footer:{
      p1:'Contact us'
    }
  },
};
